import { render, staticRenderFns } from "./Addinventory.vue?vue&type=template&id=0b1e9ee7&scoped=true"
import script from "./Addinventory.vue?vue&type=script&lang=js"
export * from "./Addinventory.vue?vue&type=script&lang=js"
import style0 from "./Addinventory.vue?vue&type=style&index=0&id=0b1e9ee7&prod&lang=scss&scoped=true"
import style1 from "./Addinventory.vue?vue&type=style&index=1&id=0b1e9ee7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1e9ee7",
  null
  
)

export default component.exports